<template>
  <div class="site-wrap">
    <template v-if="applicationReady">
      <session-timeout-modal />
      <template v-if="$route.meta.bareLayout">
        <router-view role="main" />
      </template>
      <template v-else>
        <site-header></site-header>
        <page-top>
          LENS
        </page-top>
        <div style="min-height: 60vh">
          <router-view role="main" />
          <authentication-failure-popup-modal
            ref="authenticationFailureModal"
            @close="handleModalClose"
          />
          <unauthorized-popup-modal
            ref="unauthorizedModal"
            @close="handleUnauthorizedModalClose"
          />
          <not-found-popup-modal ref="notFoundModal" />
        </div>
        <site-footer :plugin-version="appStore.getPluginVersion"></site-footer>
      </template>
    </template>
    <div class="text-center my-5 h3" v-else>
      Loading application...
    </div>
  </div>
</template>
<script lang="js">
import SiteHeader from "@/src/components/shared/SiteHeader.vue";
import SiteFooter from "@/src/components/shared/SiteFooter.vue";
import {useAppCoreStore} from "@/src/stores/app-core";
import PageTop from "@/src/components/shared/PageTop.vue";
import AuthenticationFailurePopupModal from '@/src/components/AuthenticationFailurePopupModal.vue'
import UnauthorizedPopupModal from "@/src/components/UnauthorizedPopupModal.vue";
import NotFoundPopupModal from "@/src/components/NotFoundPopupModal.vue";
import SessionTimeoutModal from "@/src/components/SessionTimeoutModal.vue";
import { modalActionsMixin } from "./mixins/modalActionsMixin";
import { rememberCurrentPage } from "@/src/services/session/returnPage";
export default {
  setup() {
    const appStore = useAppCoreStore();
    return {
      appStore
    }
  },
  mixins: [ modalActionsMixin ],
  components: {
    SiteHeader,
    SiteFooter,
    PageTop,
    AuthenticationFailurePopupModal,
    UnauthorizedPopupModal,
    NotFoundPopupModal,
    SessionTimeoutModal
  },
  data() {
    return {
      currentUser: null,
      loading: false,
      error: null,
      modalMessage: null
    }
  },
  computed: {
    applicationReady() {
      return !this.loading && this.appStore.currentUser;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.appStore.loadApplicationData();
      await this.appStore.loadCurrentUser();
      this.checkPermissions()
    } catch(error) {
      this.error = error;
    }
    this.loading = false;
  },
  methods: {
    // If we have a user and the route we are on requires permissions then check them and redirect if not allowed
    checkPermissions() {
      if(this.appStore.currentUser && this.$route.meta.permissions) {
        this.$route.meta.permissions.forEach((permission) => {
          if(this.$appStore.currentUser.canDo(permission, this.$route.meta.permissionsKey ? this.$route.meta.permissionsKey : 'read')) {
            return
          }
        })
        this.$router.push({name: 'app-root'})
      }
    },
    // The session ended, reloading goes to the login page. Return here after logging in.
    handleModalClose() {
      rememberCurrentPage();
      window.location.reload();
    },
    handleUnauthorizedModalClose() {
      // Close any background modals that might have been open when the user was unauthorized
      this.closeAllModals()      
      this.$router.push({name: 'app-root'})
    },
    displayLogoutModal() {
      $('#authenticationFailureModal').modal();
    },
    displayUnauthorizedModal() {
      $('#unauthorizedModal').modal();
    },
    displayNotFoundModal() {
      $('#notFoundModal').modal();
    }
  },
  created() {
    window.displayLogoutModal = this.displayLogoutModal;
    window.displayUnauthorizedModal = this.displayUnauthorizedModal;
    window.displayNotFoundModal = this.displayNotFoundModal;
  }
}

</script>
